import { isSafari } from "@utils/design-tokens";
import React from "react";
import { TextProps } from "react-native";
import styled, { css } from "styled-components/native";
import { useTheme } from "styled-components/native";

type StyledTextProps = TextProps & {
  color?: string;
  children: any;
  type?: any;
  isUnderlined?: boolean;
  isBold?: boolean;
  textAlign?: string;
  selectable?: boolean;
  ref?: any;
  isUpperCase?: boolean;
  fontSize?: number;
  onPress?: () => void;
  textDecoration?: string;
};

const StyledText = ({
  color,
  type,
  textAlign = "left",
  isUnderlined,
  isBold,
  children,
  numberOfLines,
  ellipsizeMode,
  selectable = false,
  ref,
  isUpperCase = false,
  fontSize,
  onPress,
  textDecoration,
}: StyledTextProps) => {
  const theme = useTheme();
  const localColor = color ?? theme["core-06"];

  return (
    <CustomText
      ref={ref}
      style={[
        type,
        isSafari()
          ? {
              WebkitFontSmoothing: "antialiased",
              MozOsxFontSmoothing: "grayscale",
            }
          : {},
        fontSize && { fontSize: fontSize },
        textDecoration && { textDecorationLine: textDecoration },
      ]}
      color={localColor}
      isUnderlined={isUnderlined}
      isBold={isBold}
      textAlign={textAlign}
      selectable={selectable}
      selectionColor="rgba(0, 0, 0, 0.5)"
      numberOfLines={numberOfLines}
      ellipsizeMode={ellipsizeMode}
      allowFontScaling={false}
      isUpperCase={isUpperCase}
      fontSize={fontSize}
      {...(onPress ? { onPress } : {})}
    >
      {children}
    </CustomText>
  );
};

const CustomText = styled.Text<StyledTextProps>`
  color: ${({ color }: { color?: string }) => color};
  text-decoration-line: ${({ isUnderlined }: { isUnderlined?: boolean }) =>
    isUnderlined ? "underline" : "none"};
  ${(props: { isBold?: boolean }) =>
    props.isBold &&
    css`
      font-weight: 700;
    `};
  text-align: ${({ textAlign }: { textAlign?: string }) => textAlign};
  ${({ isUpperCase }: { isUpperCase?: boolean }) =>
    isUpperCase &&
    css`
      text-transform: uppercase;
    `}
`;

export default StyledText;
